import { Image } from '@chakra-ui/react';
import React from 'react';

export default function TopNavigationLogo(props) {
    const { application, variant } = props;

    const { publicImageUrl, theme } = application;
    const { layout, logo_format } = theme;

    const url = `${publicImageUrl}${layout}/logos/logo.${logo_format}`

    const height = logo_format === "svg" && variant === "explore"
      ? "32px"
      : "auto";

      const dims = {
        login: {
          maxX: "250px",
          y: "48px",
          maxY: "48px",
        },
        explore: {
          maxX: "144px",
          y: "",
          maxY: "32px",
        },
        email: {
          maxX: "",
          y: "40px",
          maxY: "40px",
        },
      };

    return (
        <Image
      src={url}
      alt="Company Logo"
      display="inline-block"
      maxWidth={dims[variant].maxX}
      height={height}
      maxHeight={dims[variant].maxY}
    />
    )
}